import { withInstall } from '@element-plus/utils/with-install'

import Image from './src/image.vue'

export const ElImage = withInstall(Image)
export default ElImage

export * from './src/image'
